import { useState } from 'react';
import { useLang } from '../LangContext';
import translations from '../i18n';

export default function Programma() {
  const { lang } = useLang();
  const t = translations[lang].programma;
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section id="programma" style={{ padding: '120px 0', background: '#ffffff' }}>
      <div style={{ padding: '0 40px' }}>
        <h2 className="section-title reveal" style={{ color: 'var(--red)' }}>{t.title}</h2>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 40px' }}>
        <div className="reveal" style={{ marginBottom: '64px', padding: '28px 32px', border: '1px solid rgba(0,0,0,0.08)', borderLeft: '3px solid var(--red)', background: 'rgba(229,0,60,0.03)' }}>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '9px', letterSpacing: '0.3em', color: '#888', textTransform: 'uppercase', marginBottom: '16px' }}>{t.preliminary}</p>
          {t.sessions.map((s, i) => (
            <div key={i} style={{ display: 'flex', gap: '16px', marginBottom: i < t.sessions.length - 1 ? '10px' : 0 }}>
              <span style={{ fontFamily: 'var(--font-title)', color: 'var(--red)', fontSize: '1rem' }}>+</span>
              <div>
                <span style={{ fontFamily: 'var(--font-body)', fontWeight: 700, color: '#111', fontSize: '1rem' }}>{s.label}</span>
                <span style={{ fontFamily: 'var(--font-body)', color: '#666', marginLeft: '12px', fontSize: '0.95rem' }}>{s.date}</span>
              </div>
            </div>
          ))}
        </div>

        <div>
          {t.eventi.map((ev, i) => (
            <div key={i} className="reveal" style={{ transitionDelay: `${i * 0.06}s` }}
              onClick={() => setActiveIndex(activeIndex === i ? null : i)}>
              <div style={{
                display: 'grid', gridTemplateColumns: '88px 1fr 16px', gap: '20px',
                padding: '22px 0', borderBottom: '1px solid rgba(0,0,0,0.08)',
                cursor: 'pointer', transition: 'all 0.3s',
                background: activeIndex === i ? 'rgba(229,0,60,0.03)' : 'transparent',
                paddingLeft: activeIndex === i ? '16px' : '0',
              }}>
                <div style={{ fontFamily: 'var(--font-title)', fontWeight: 600, fontSize: '12px', color: 'var(--red)', paddingTop: '2px' }}>{ev.date}</div>
                <div>
                  <div style={{ fontFamily: 'var(--font-body)', fontSize: '9px', letterSpacing: '0.25em', color: '#999', textTransform: 'uppercase', marginBottom: '4px' }}>{ev.type}</div>
                  <div style={{ fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: '1.05rem', color: '#111', marginBottom: activeIndex === i ? '8px' : 0, transition: 'margin 0.3s' }}>"{ev.title}"</div>
                  {activeIndex === i && ev.location && (
                    <div style={{ fontFamily: 'var(--font-body)', fontSize: '0.875rem', color: '#666', animation: 'fadeIn 0.3s ease' }}>{ev.location}</div>
                  )}
                </div>
                <div style={{ color: 'var(--red)', fontSize: '18px', alignSelf: 'center', transition: 'transform 0.3s', transform: activeIndex === i ? 'rotate(45deg)' : 'none' }}>+</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`@keyframes fadeIn { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </section>
  );
}
